module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dsp-box"
  }, [(_vm.loaded && _vm.list.length === 0) ? _c('kong') : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.list.length > 0),
      expression: "list.length > 0"
    }],
    ref: "swiper",
    staticClass: "dsp-swiper",
    class: {
      'dsp-swiper--narrow': _vm.showComment
    },
    on: {
      "scroll": _vm.handleScroll,
      "wheel": _vm.handleWheel,
      "touchstart": _vm.handleTouchStart,
      "touchmove": _vm.handleTouchMove,
      "touchend": _vm.handleTouchEnd,
      "mousedown": _vm.handleDragDown,
      "contextmenu": function($event) {
        $event.preventDefault();
      }
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: item.id || index,
      staticClass: "dsp-swiper-item"
    }, [_c('div', {
      staticClass: "dsp-video-wrap"
    }, [(item.coverUrl) ? _c('img', {
      staticClass: "dsp-video-bg",
      attrs: {
        "src": item.coverUrl
      }
    }) : _vm._e(), _vm._v(" "), (!item.playing && !_vm.leaving && !_vm.isWheelLock && !_vm.isDragging && !_vm.isTouching && !_vm.snapAnimating) ? _c('img', {
      staticClass: "dsp-play-btn",
      attrs: {
        "src": _vm.spBf
      }
    }) : _vm._e(), _vm._v(" "), (index === _vm.currentIndex && item.buffering) ? _c('div', {
      staticClass: "dsp-loading"
    }) : _vm._e(), _vm._v(" "), (index === _vm.currentIndex && !_vm.leaving) ? _c('div', {
      staticClass: "dsp-fullscreen-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleFullscreen.apply(null, arguments)
        }
      }
    }, [(!_vm.isFullscreen) ? _c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "width": "18",
        "height": "18",
        "fill": "none",
        "stroke": "#FFFFFF",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    }, [_c('path', {
      attrs: {
        "d": "M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"
      }
    })]) : _c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "width": "18",
        "height": "18",
        "fill": "none",
        "stroke": "#FFFFFF",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    }, [_c('path', {
      attrs: {
        "d": "M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5"
      }
    })])]) : _vm._e(), _vm._v(" "), _c('video', {
      ref: 'video' + index,
      refInFor: true,
      staticClass: "dsp-video",
      attrs: {
        "src": _vm.videoSrc(item, index),
        "poster": item.coverUrl || '',
        "loop": "",
        "playsinline": "",
        "webkit-playsinline": "",
        "preload": "auto"
      },
      on: {
        "click": function($event) {
          return _vm.handleVideoClick(index)
        },
        "dblclick": function($event) {
          return _vm.handleVideoDblClick(item)
        },
        "timeupdate": function($event) {
          return _vm.onTimeUpdate(index)
        },
        "loadedmetadata": function($event) {
          return _vm.onLoadedMetadata(index)
        },
        "play": function($event) {
          return _vm.onVideoPlay(index)
        },
        "pause": function($event) {
          return _vm.onVideoPause(index)
        },
        "waiting": function($event) {
          return _vm.onVideoWaiting(index)
        },
        "playing": function($event) {
          return _vm.onVideoPlaying(index)
        },
        "canplay": function($event) {
          return _vm.onVideoCanPlay(index)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "dsp-info"
    }, [_c('span', {
      staticClass: "dsp-info-user"
    }, [_vm._v(_vm._s(item.nickName))]), _vm._v(" "), _c('span', {
      staticClass: "dsp-info-title"
    }, [_vm._v(_vm._s(item.title || ''))])]), _vm._v(" "), _c('div', {
      staticClass: "dsp-actions"
    }, [_c('div', {
      staticClass: "dsp-actions-item"
    }, [_c('img', {
      staticClass: "dsp-actions-avatar",
      attrs: {
        "src": item.headPortrait
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleGoUserHome(item)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "actions"
    }, [_c('div', {
      staticClass: "dsp-actions-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleToggleLike(item)
        }
      }
    }, [_c('img', {
      staticClass: "dsp-actions-icon",
      attrs: {
        "src": item.isGiveLike === 1 ? _vm.spDz2 : _vm.spDz1
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "dsp-actions-count"
    }, [_vm._v(_vm._s(item.giveLikeNumber || 0))])]), _vm._v(" "), (item.commentStatus == 1) ? _c('div', {
      staticClass: "dsp-actions-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleShowComment(item)
        }
      }
    }, [_c('img', {
      staticClass: "dsp-actions-icon",
      attrs: {
        "src": _vm.spPinglun
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "dsp-actions-count"
    }, [_vm._v(_vm._s(item.commentNumber || 0))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "dsp-actions-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleToggleCollect(item)
        }
      }
    }, [_c('img', {
      staticClass: "dsp-actions-icon",
      attrs: {
        "src": item.isCollect === 1 ? _vm.spShoucang2 : _vm.spShoucang1
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "dsp-actions-count"
    }, [_vm._v(_vm._s(item.collectNumber || 0))])])])]), _vm._v(" "), _c('div', {
      staticClass: "dsp-progress",
      on: {
        "mousedown": function($event) {
          $event.stopPropagation();
          return _vm.handleProgressDown($event, index)
        }
      }
    }, [_c('div', {
      staticClass: "dsp-progress-track"
    }, [_c('div', {
      staticClass: "dsp-progress-fill",
      style: ({
        width: _vm.progressPercent(item) + '%'
      })
    })])]), _vm._v(" "), _c('div', {
      staticClass: "dsp-controls"
    }, [_c('div', {
      staticClass: "dsp-controls-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.togglePlay(index)
        }
      }
    }, [(item.playing) ? _c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "width": "18",
        "height": "18"
      }
    }, [_c('path', {
      attrs: {
        "d": "M7 5h3.4v14H7zM13.6 5H17v14h-3.4z",
        "fill": "#FFFFFF"
      }
    })]) : _c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "width": "18",
        "height": "18"
      }
    }, [_c('path', {
      attrs: {
        "d": "M8 5l11 7-11 7V5z",
        "fill": "#FFFFFF"
      }
    })])]), _vm._v(" "), _c('span', {
      staticClass: "dsp-controls-time"
    }, [_vm._v(_vm._s(_vm.formatTime(item.pTime)) + " / " + _vm._s(_vm.formatTime(item.dTime)))]), _vm._v(" "), _c('div', {
      staticClass: "dsp-controls-input",
      on: {
        "mousedown": function($event) {
          $event.stopPropagation();
        },
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('div', {
      staticClass: "dsp-bar-emoji-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleBarEmoji.apply(null, arguments)
        }
      }
    }, [_c('div', {
      staticClass: "dsp-bar-emoji-face",
      class: {
        'dsp-bar-emoji-face--active': _vm.barEmojiShow
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.barInput),
        expression: "barInput"
      }],
      staticClass: "dsp-controls-field",
      attrs: {
        "placeholder": _vm.$t('all.shuodianshenme')
      },
      domProps: {
        "value": (_vm.barInput)
      },
      on: {
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          $event.preventDefault();
          return _vm.submitBarComment.apply(null, arguments)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.barInput = $event.target.value
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "dsp-controls-send",
      class: {
        'dsp-controls-send--loading': _vm.barSubmitting
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.submitBarComment.apply(null, arguments)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('all.fabiao')))])]), _vm._v(" "), _c('div', {
      staticClass: "dsp-controls-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleMute(index)
        }
      }
    }, [_c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "width": "18",
        "height": "18"
      }
    }, [_c('path', {
      attrs: {
        "d": "M4 9v6h4l5 4V5L8 9H4z",
        "fill": "#FFFFFF"
      }
    }), _vm._v(" "), (!_vm.muted) ? _c('path', {
      attrs: {
        "d": "M16.5 8.5a5 5 0 010 7M18.5 6a8 8 0 010 12",
        "stroke": "#FFFFFF",
        "stroke-width": "1.6",
        "fill": "none",
        "stroke-linecap": "round"
      }
    }) : _c('path', {
      attrs: {
        "d": "M16 9l5 6M21 9l-5 6",
        "stroke": "#FFFFFF",
        "stroke-width": "1.6",
        "fill": "none",
        "stroke-linecap": "round"
      }
    })])])]), _vm._v(" "), (_vm.barEmojiShow) ? _c('div', {
      staticClass: "dsp-bar-emoji-panel",
      on: {
        "mousedown": function($event) {
          $event.stopPropagation();
        },
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('div', {
      staticClass: "dsp-bar-emoji-grid"
    }, _vm._l((_vm.emojiList), function(e, ei) {
      return _c('span', {
        key: ei,
        staticClass: "dsp-bar-emoji-item",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.pickBarEmoji(e)
          }
        }
      }, [_vm._v(_vm._s(e))])
    }), 0)]) : _vm._e()])
  }), 0), _vm._v(" "), (_vm.showComment && _vm.currentVideo) ? _c('div', {
    staticClass: "dsp-comment"
  }, [_c('div', {
    staticClass: "dsp-comment-header"
  }, [_c('span', {
    staticClass: "dsp-comment-title"
  }, [_vm._v(_vm._s(_vm.currentVideo.commentNumber || 0) + " " + _vm._s(_vm.$t('all.pinglun')))]), _vm._v(" "), _c('div', {
    staticClass: "dsp-comment-close",
    on: {
      "click": function($event) {
        _vm.showComment = false
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "16",
      "height": "16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6 6l12 12M18 6L6 18",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })])])]), _vm._v(" "), _c('pinglun', {
    ref: "pinglun",
    staticClass: "dsp-comment-body",
    attrs: {
      "videoId": _vm.currentVideo.id
    },
    on: {
      "count-change": _vm.onCommentCountChange
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5679ba0e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/duanshippin/duanshippin.vue
// module id = 1022
// module chunks = 1